<template>
  <v-container>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-toolbar color="red darken-3" dark elevation="0">
          <v-toolbar-title>Atenção!</v-toolbar-title>
        </v-toolbar>
        <v-card-text> <p class="text-h6 text-center font-weight-black"> O Período de incrições desta chamada está encerrado!</p>
          
        </v-card-text>
        <v-card-actions>
          <v-btn color="red lighten-1" dark @click="sair">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import * as PreMatriculaService from "@/services/prematricula.service";

export default {
  name: "home",
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {
    this.loadDadosCandidato();
  },
  methods: {
    loadDadosCandidato() {
      this.$nprogress.start();
      PreMatriculaService.getStatusCandidato()
        .then((res) => {
          console.log(res)
          var dc = res.data;
          if (dc.role != "CANDIDATO") {
            this.$router.push("/");
          }
          if (dc.status == "EM_INSCRICAO")
            this.$router.push("/inscricao");

          if (dc.status == "ACOMPANHAMENTO")
            this.$router.push("/acompanhamento");

          if (dc.status == "PRAZO_EXPIRADO"){
            this.dialog = true;
          }
        })
        .finally(() => this.$nprogress.done());
    },
    sair(){
      this.$store.dispatch('logout');
      this.$router.push("/");
    }
  },
};
</script>
